import { types } from "../action_types";

const initialState = {
  suspiciousActivities: null,
  suspiciousActivitiesLoading: false,
  antiCheatStats: null,
  antiCheatStatsLoading: false,
  resolveLoading: false,
};

const AntiCheatReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GetSuspiciousActivitiesRequest:
      return { ...state, suspiciousActivitiesLoading: true };
    case types.GetSuspiciousActivitiesRequestSuccess:
      return { ...state, suspiciousActivities: action.payload, suspiciousActivitiesLoading: false };
    case types.GetSuspiciousActivitiesRequestFailure:
      return { ...state, suspiciousActivitiesLoading: false };

    case types.GetAntiCheatStatsRequest:
      return { ...state, antiCheatStatsLoading: true };
    case types.GetAntiCheatStatsRequestSuccess:
      return { ...state, antiCheatStats: action.payload, antiCheatStatsLoading: false };
    case types.GetAntiCheatStatsRequestFailure:
      return { ...state, antiCheatStatsLoading: false };

    case types.ResolveSuspiciousActivityRequest:
      return { ...state, resolveLoading: true };
    case types.ResolveSuspiciousActivityRequestSuccess: {
      const updatedDocs = state.suspiciousActivities?.docs?.map((doc) =>
        doc.id === action.payload.id ? { ...doc, resolved: true, resolution: action.payload.resolution } : doc
      );
      return {
        ...state,
        resolveLoading: false,
        suspiciousActivities: state.suspiciousActivities
          ? { ...state.suspiciousActivities, docs: updatedDocs }
          : null,
      };
    }
    case types.ResolveSuspiciousActivityRequestFailure:
      return { ...state, resolveLoading: false };

    default:
      return state;
  }
};

export default AntiCheatReducer;
